import { isWESCoachV2Enabled } from 'bundles/wes-common/utils/experimentUtils';

export const WES_COACH_MODE_ID = 'WES_CHECKOUT';
export const WES_COACH_MODE_ID_V2 = 'WES_CHECKOUT_V2';
export const WES_ASK_COURSERA_HEADER_SLOT_ID = 'wes-ask-coursera-header-slot';
export const WES_CHATBOT_DIALOG_ID = 'wes-chatbot-dialog';

export type AdditionalContextItem = {
  contextKey: string;
  contextValue: string;
};

export type ContextConfigType = {
  config: {
    coachModeId: string;
    coachActionId: string;
  };
  additionalContext: AdditionalContextItem[];
  courseraContext: Record<string, unknown>;
};

export const CONTEXT_CONFIG: ContextConfigType = {
  config: {
    coachModeId: WES_COACH_MODE_ID,
    coachActionId: 'ASSISTANT_PUBLIC',
  },
  additionalContext: [],
  courseraContext: {},
};

export const CONTEXT_CONFIG_V2: ContextConfigType = {
  config: {
    coachModeId: WES_COACH_MODE_ID_V2,
    coachActionId: 'ASSISTANT_PUBLIC',
  },
  additionalContext: [],
  courseraContext: {},
};

export const getActiveCoachModeId = () => {
  return isWESCoachV2Enabled() ? WES_COACH_MODE_ID_V2 : WES_COACH_MODE_ID;
};
